import script from "./SignInView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignInView.vue?vue&type=script&setup=true&lang=ts"

import "./SignInView.vue?vue&type=style&index=0&id=0a004948&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a004948"]])

export default __exports__